<mic-modal #modal (result)="onModalClosed($event)"></mic-modal>
<ng-template #modalContent>
  @if (!loading) {
    <div class="flex flex-col gap-4" [formGroup]="form">
      <p class="mb-0">Selecione uma montadora para filtrar o relatório unificado:</p>
      <app-select-form-field
        label="Montadora"
        [control]="automaker"
        [options]="automakers"
        [display]="displayName"
      ></app-select-form-field>
      <div class="text-xs opacity-70">Em branco = exportação geral.</div>
    </div>
  } @else {
    <div class="flex items-center justify-center p-6"><mat-spinner diameter="32"></mat-spinner></div>
  }
</ng-template>
